<!--
   Created by qing on 2020/1/22 10:27 上午
   Des: 矩形树图
-->
<template>
  <div
    v-if="value && value.xAxis && value.series && value.series.length"
    class="statistics__tree_map"
    ref="treeMap">
  </div>
  <div
    v-else
    :key="emptyKey"
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>


<script>
  import {clone} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        emptyKey: Math.random(),
        optConf: {
          tooltip: {
            trigger: 'item',
            showContent: true,
          },
          label: {
            show: true, // 显示图表标签
            position: 'top',
            formatter: '{b}'
          },
          series: {
            name: '',
            type: 'treemap',
            breadcrumb: {
              show: false
            },
            label: { //描述了每个矩形中，文本标签的样式。
              normal: {
                show: true,
                position: ['10%', '10%'],
              }
            },
            upperLabel: {
              show: true,
              height: 50
            },
            itemStyle: {
              normal: {
                color: '#F89588',
                borderColor : '#555'
              }
            },
            data: [
              /*
              {
                name: '北京',
                value: [20, 40, 40],
                children: [{
                  name: 'iOS',
                  value: [4, 40, 2],
                }, {
                  name: 'Android',
                  value: [6, 60, 10],
                }],
                itemStyle: {
                  color: '#F89588'
                },
              },
               */
            ],
            levels: [
              {
                itemStyle: {
                  borderColor: '#777',
                  borderWidth: 0,
                  gapWidth: 1
                },
                upperLabel: {
                  show: false
                }
              },
              {
                itemStyle: {
                  borderColorSaturation: 0.5,
                  borderWidth: 1,
                  gapWidth: 1
                },
              },
              {
                itemStyle: {
                  borderWidth: 1,
                  gapWidth: 1,
                  borderColorSaturation: 0.6
                }
              },
              {
                itemStyle: {
                  borderWidth: 1,
                  gapWidth: 1,
                  borderColorSaturation: 0.7
                }
              },
              {
                itemStyle: {
                  borderWidth: 1,
                  gapWidth: 1,
                  borderColorSaturation: 0.8
                }
              }
            ]

          }
        },
        chart: null,
        loaded: false,
      }
    },
    mounted() {
        if (this.$refs.treeMap) {
          const chart = this.$ECharts.init(this.$refs.treeMap)
          chart.title = ''
          this.chart = chart
          this.initChart()
        }

    },
    methods: {
      // 重新初始化图表 父级可调用
      initChart() {
        this.$nextTick(() => {
          if (!this.chart && this.$refs.treeMap) {
            const chart = this.$ECharts.init(this.$refs.treeMap)
            chart.title = ''
            this.chart = chart
          }
          if (this.value && this.chart) {
            const opt = clone(this.optConf)
            opt.color = this.showPropertiesHolder.theme.value
            let colorOpt = this.showPropertiesHolder.theme.value
            const showFieldsColor = this.showPropertiesHolder.showFieldsColor
            const colors = this.showPropertiesHolder.colors ? this.showPropertiesHolder.colors : []
            const value = this.value
            if (value && value.xAxis && value.series && value.series.length) {

              Object.assign(opt.tooltip, this.current.toolTipsOpts) // 默认配置
              // opt.tooltip.formatter = info => {    //自定义tooltip鼠标浮动提示，返回HTML
              //   let value = info.value;
              //
              //   let treePathInfo = info.treePathInfo;
              //   let treePath = [];
              //
              //   for (let i = 1; i < treePathInfo.length; i++) {
              //     treePath.push(treePathInfo[i].name);
              //   }
              //
              //   let value1 = value[0];
              //   value1 = this.isValidNumber(value1)
              //     ? this.$ECharts.format.addCommas(value1)
              //     : '-';
              //   let value2 = value[1];
              //   value2 = this.isValidNumber(value2)
              //     ? value2.toFixed(2) + '%'
              //     : '-';
              //   let value3 = value[2];
              //   value3 = this.isValidNumber(value3)
              //     ? value3.toFixed(2) + '%'
              //     : '-';
              //
              //   if(treePathInfo.length === 2) {
              //     // 第一级
              //     return [
              //       '<div class="tooltip-title">' + this.$ECharts.format.encodeHTML(treePath.join('-')) + '</div>',
              //       info.seriesName + ': &nbsp;&nbsp;' + value1 + '<br>',
              //       '占总值: &nbsp;&nbsp;' + value2
              //     ].join('');
              //
              //   } else {
              //
              //     return [
              //       '<div class="tooltip-title">' + this.$ECharts.format.encodeHTML(treePath.join('-')) + '</div>',
              //       info.seriesName + ': &nbsp;&nbsp;' + value1 + '<br>',
              //       '占总值: &nbsp;&nbsp;' + value2 + '<br>',
              //       '占'+ treePath[0]+': &nbsp;&nbsp;' + value3
              //     ].join('');
              //   }
              //
              // }

              opt.series.name = value.xAxis.name
              opt.series.id = value.xAxis.dataId
              opt.series.data = value.series
              // 设置颜色
              opt.series.data.forEach((item, idx) => {
                // let color = colorOpt[idx] || colorOpt[0]
                const colorItem = colors.filter(c => c.name === item.name)[0]
                let color = colorItem ? colorItem.color : opt.color[idx] || opt.color[0]
                item.itemStyle = {
                  color
                }
              })

              try {
                opt.series.upperLabel.formatter = (info) => {
                  let value = info.value;
                  return info.name + ':'+ formatNum(Number(value[value.length - 3]))  + '\n'
                    + value[value.length - 2] + '%'
                }

                opt.series.label.formatter = (info) => {
                  let value = info.value;
                  return info.name + ':'+ formatNum(Number(value[value.length - 3])) + '\n'
                    + value[value.length - 2] + '%'
                }
              } catch (e) {
                console.error(e)
              }

              if (!opt.series.data) {
                this.$toast.fail("没有数据")
                return
              }
              this.chart.setOption(opt, true, false, true)
              this.resize()
            } else {
              this.chart.clear()
              this.emptyKey = Math.random()
              this.chart = null
            }
            this.chart.on('click', params => {
              console.log('click',params)
              this.showDataDrillDownList(params)
            });
          }
        })
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      },
      isValidNumber(num) {
        return num != null && isFinite(num)

      }
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .statistics__tree_map {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
